module.exports = __webpack_public_path__ + "img/icon-instagram.6c90375a.svg";